import { render, staticRenderFns } from "./MiniCartWidget.vue?vue&type=template&id=3ba43ce9&"
import script from "./MiniCartWidget.vue?vue&type=script&lang=js&"
export * from "./MiniCartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports